export class NewMessageDto {
    public equipeId: string;
    public remetenteId: number;
    public mensagem: string;
    public dataHora: any;
}